/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs as  } from "relay-runtime";
export type SuspectWordListConfig_formValues = {
    readonly wordList: {
        readonly suspect: ReadonlyArray<string>;
    };
    readonly premoderateSuspectWords: boolean;
    readonly " $refType": "SuspectWordListConfig_formValues";
};
export type SuspectWordListConfig_formValues$data = SuspectWordListConfig_formValues;
export type SuspectWordListConfig_formValues$key = {
    readonly " $data"?: SuspectWordListConfig_formValues$data;
    readonly " $fragmentRefs": FragmentRefs<"SuspectWordListConfig_formValues">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SuspectWordListConfig_formValues",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "WordList",
            "kind": "LinkedField",
            "name": "wordList",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "suspect",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "premoderateSuspectWords",
            "storageKey": null
        }
    ],
    "type": "Settings",
    "abstractKey": null
} as any;
(node as any).hash = 'fcd5e80fed8174666a70b2c13750eefb';
export default node;
